import { useEffect, useState, useMemo, createContext, useContext } from 'react';
import { useEsri } from './EsriContext';

import { APP_SETTINGS, ARCGIS_SERVICES_ROOT_URL } from './settings';
const { GIS_SERVER } = APP_SETTINGS;
const { GP } = GIS_SERVER;

const initialState = {
  service_list: null,
  download_layer_info: null,
  token: null,
  active_overlay: null,
};
const AppContext = createContext();

const AppStateProvider = ({ children }) => {
  const [appState, setAppState] = useState(initialState);
  const stateValues = useMemo(() => [appState, setAppState], [appState]);
  const { esriLoader, registerToken, geoProcessor } = useEsri();

  useEffect(() => {
    if (!esriLoader) return;
    (async function () {
      const gpTokenService = await geoProcessor(GP.TOKEN_INFO_URL);
      const { results: tokenResult } = await gpTokenService.execute();
      if (tokenResult[0]['value']) {
        const token = tokenResult[0]['value'];
        const tokenJSON = {
          token: token,
          server: ARCGIS_SERVICES_ROOT_URL,
          ssl: true,
        };
        registerToken(tokenJSON);

        const gpServiceList = await geoProcessor(GP.LIST_OF_SERVICE_URL);
        const { results: serviceResults } = await gpServiceList.execute();
        const serviceListValues = serviceResults[0]['value'];

        const gpServiceDownloadInfo = await geoProcessor(
          GP.DOWNLOAD_LAYER_INFO
        );
        const { results: serviceDownloadInfo } =
          await gpServiceDownloadInfo.execute();

        const serviceDownloadInfoResults = serviceDownloadInfo[0]['value'];

        if (token && serviceListValues) {
          const getOverlayAlias = Object.keys(serviceListValues).reduce(
            (a, s) => {
              a[`${serviceListValues[s].alias}`] = { status: true };
              return a;
            },
            []
          );
          setAppState({
            service_list: serviceListValues,
            download_layer_info: serviceDownloadInfoResults,
            token: token,
            active_overlay: getOverlayAlias,
          });
        }
      }
    })();
  }, [esriLoader, geoProcessor, registerToken]);

  return (
    <AppContext.Provider value={stateValues}>{children}</AppContext.Provider>
  );
};

const useAppState = () => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useAppState must be used within a <AppProvider/>');
  }
  return context;
};

export { AppStateProvider as default, useAppState };
